"use client"

import { ReactNode, useEffect } from 'react'

import { useAdminAuthStore } from '@/domains/admin/stores'
import { useNavigate } from '@tanstack/react-router'
import { createDomainAuthUtils } from '@shared/lib/auth-utils'

const adminAuthUtils = createDomainAuthUtils('admin')

interface RedirectIfAuthenticatedProps {
  children: ReactNode
}
export function RedirectIfAuthenticated({ children }: RedirectIfAuthenticatedProps) {
  const navigate = useNavigate()
  const { isAuthenticated } = useAdminAuthStore()

  useEffect(() => {
    const isTokenValid = adminAuthUtils.isAuthenticated()
    
    if (isAuthenticated && isTokenValid) {
      navigate({ to: '/' }).catch(console.error)
    } else if (isAuthenticated && !isTokenValid) {
      const store = useAdminAuthStore.getState()
      adminAuthUtils.clearAuth()
      store.handleAuthError()
    }
  }, [isAuthenticated, navigate])


  return <>{children}</>
}